import type { ReactElement } from 'react'
import { Link } from 'react-router-dom'

export interface GameCardProps {
  readonly name: string
  readonly description: string
  readonly to: string
}

/** 整卡可点击：直接渲染成 Link，键盘可达性由 a 元素自带 */
export function GameCard({ name, description, to }: GameCardProps): ReactElement {
  return (
    <Link
      to={to}
      className="block rounded-xl border border-white/10 bg-white/5 p-5 no-underline transition hover:border-accent/60 hover:bg-white/10 focus-visible:ring-2 focus-visible:ring-accent focus-visible:outline-none"
    >
      <h3 className="text-lg font-semibold text-white">{name}</h3>
      <p className="mt-2 text-sm text-white/60">{description}</p>
      <span className="mt-4 inline-block text-sm text-accent">进入对局 →</span>
    </Link>
  )
}
